import { TCredentialsType, TNodeEnv } from '/src/lib/types';

const getEnvironmentVariable = (unvalidatedEnvironmentVariable: string | undefined, defaultValue?: string): string => {
  if (!unvalidatedEnvironmentVariable) {
    if (typeof defaultValue === 'string') return defaultValue;
    throw new Error(`Couldn't find environment variable: ${unvalidatedEnvironmentVariable}`);
  } else {
    return unvalidatedEnvironmentVariable;
  }
};

export interface IConfig {
  /**
   * Current NODE_ENV
   */
  nodeEnv: TNodeEnv;
  /**
   * Frontend URL and page title. Used to send correct CORS info with API requests
   */
  client: {
    url: string;
    basePageTitle: string;
  };
  /**
   * API URL and settings
   */
  api: {
    url: string;
    prefix?: string;
    useCredentials: boolean;
    credentialsType: TCredentialsType;
  };
  /**
   * Root namespace for debug logs
   */
  logs: {
    rootNamespace: string;
  };
}

export const config: IConfig = {
  nodeEnv: getEnvironmentVariable(process.env.NODE_ENV) as TNodeEnv,
  client: {
    url: getEnvironmentVariable(process.env.CLIENT_URL, 'http://localhost:1234'),
    basePageTitle: getEnvironmentVariable(process.env.BASE_PAGE_TITLE, 'FuSE Financial'),
  },
  api: {
    url: getEnvironmentVariable(process.env.API_URL),
    prefix: getEnvironmentVariable(process.env.API_PREFIX, 'api'),
    useCredentials: getEnvironmentVariable(process.env.API_USE_CREDENTIALS, 'false') === 'true',
    credentialsType: getEnvironmentVariable(process.env.API_CREDENTIALS_TYPE, 'include') as TCredentialsType,
  },
  logs: {
    rootNamespace: getEnvironmentVariable(process.env.LOGS_ROOT_NAMESPACE, 'fuse-frontend'),
  },
};
